import * as z from "zod";
import { numericOptionSchema } from "../common/option-schema";
import { requiredErrorMessage } from "../common/error-messages";
import { requiredNumberSchema } from "../common/required-number-schema";

export const addProductSchema = z.object({
  category: z.object(numericOptionSchema, { error: requiredErrorMessage }),
  name: z
    .string()
    .min(1, requiredErrorMessage)
    .max(100, "Name must be at most 100 characters.")
    .refine(
      (val: string) => val.length === 0 || /^[a-zA-Z0-9/\s\-_.&()']+$/.test(val),
      "Name can only contain letters, numbers, spaces, forward slashes, hyphens, underscores, periods, ampersands, parentheses, and apostrophes."
    ),
  brand: z.object(numericOptionSchema, { error: requiredErrorMessage }),
  size_value: requiredNumberSchema(
    z
      .number()
      .min(0, { message: "Size must be at least 0." })
      .max(999999999, { message: "Size must be at most 999,999,999." })
      .multipleOf(0.01, { message: "Size can be up to 2 decimal places." })
  ),
  size_unit: z
    .string()
    .min(1, requiredErrorMessage),
  cost_price: requiredNumberSchema(
    z
      .number()
      .min(0, { message: "Cost price must be at least 0." })
      .max(9999999999, { message: "Cost price must be at most 9,999,999,999." })
      .multipleOf(0.01, { message: "Cost price can be up to 2 decimal places." })
  ),
  retail_price: requiredNumberSchema(
    z
      .number()
      .min(0, { message: "Retail price must be at least 0." })
      .max(9999999999, { message: "Retail price must be at most 9,999,999,999." })
      .multipleOf(0.01, { message: "Retail price can be up to 2 decimal places." })
  ),
});
